import { onMediaSessionUpdate } from "../castEvents/mediaSession/onMediaSessionUpdate";
import { addPlayerControllerListeners } from "./playerControllerListeners";

export function addCastMediaSessionListeners(media: chrome.cast.media.Media) {
    addPlayerControllerListeners(); // player controller listeners must be re-added every time there is a new media session
    media.addUpdateListener(onMediaSessionUpdate);
}
